import { Component, OnInit } from '@angular/core';
declare var jquery: any;
declare var $: any;
import 'datatables.net';
import { GridOptions } from "ag-grid/main";
import { ActivatedRoute, Router } from "@angular/router";
import { Globals } from '../../globals';
import { ToastrService } from 'ngx-toastr';
import { ClientsService, RaterDto } from 'app/services/client/ClientsService';



@Component({
  selector: 'app-pending-assessments',
  templateUrl: './pending-assessments.component.html',
  styleUrls: ['./pending-assessments.component.scss']
})
export class PendingAssessmentsComponent implements OnInit {

    assessments: any[] = [];
    assessmentsHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridApiModal;
    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;

    rowSelection: string;

    loading: boolean = true;
    canTakeAssessment: boolean = false;
    is360: boolean = false;


    /*Raters*/
    raters: any[] = [];
    ratersHeaders: any[];


    /*new rater*/
    rater = {
        "email": "",
        "raterType": 0
    }
    raterTypes: any[] = [];
    asignmentId: number;


    constructor(
        private _ClientsService: ClientsService,
        private router: Router,
        private _Globals: Globals,
        private _toastr: ToastrService
    ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "single";
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.assessmentsHeaders = this.createHeaders();

        this.getClientPendingAssessments();
        this.getRaterTypes();
    }


    //----------------------------------------
    //------------------ag-grid----------------
    //----------------------------------------

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canTakeAssessment = true;
            let currentRowSelected = this.getSelectedRows();
            if (currentRowSelected[0].Is360) {
                this.is360 = true;
            } else {
                this.is360 = false;
            }

        } else {
            this.canTakeAssessment = false;
            this.is360 = false;
        }   
    }

    showModal() {
        $("#ratersModal").modal({ backdrop: "static" });
        $('#ratersModal').modal('show');
        
    }

    closeModal() {
        $('#ratersModal').modal('hide');
    }

    onRowSelected(event) {
        console.log("onRowSelected", event);
    }

    ratersModal() {
        if (this.is360) {
            this.ratersHeaders = this.createRatersHeaders();
            let currentRowSelected = this.getSelectedRows();
            this.getRaters(currentRowSelected[0].AssignmentId);
            this.showModal();
        }
    }

    takeAssessmentSelected() {
        if (this.canTakeAssessment) {
            let data = this.getSelectedRows();
            let assessmentId = data[0].AssessmentId;
            let assignmentId = data[0].AssignmentId;
            let language = data[0].Language;
            let name = data[0].Name;

            this.router.navigate(['/app/assigned_assessment', 'pending', assessmentId, assignmentId, name, language], { state: {showBanner: false} });
        }
    }

    getSelectedRows(): any {
        console.log("SELECTED", this.gridApi.getSelectedRows());
        return this.gridApi.getSelectedRows();
    }

    getClientPendingAssessments() {
        this._ClientsService.getClientPendingAssessments().subscribe((data: any) => {
            //console.log('response_GetClientPendingAssessments', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetClientPendingAssessments', _data);

                this.assessments = _data;
                this.loading = false;
            } 

            
        });
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi:any) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit(this.gridApi);
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 500);
    }

    createHeaders() {
        let columnDefs = new Array();

        //let checkHeader = {
        //    headerName: '',
        //    field: '',
        //    headerCheckboxSelection: true,
        //    headerCheckboxSelectionFilteredOnly: true,
        //    checkboxSelection: true,
        //    minWidth: 30,
        //    width: 30,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return '';
        //    }
        //};
        //columnDefs.push(checkHeader);

        //let actionsHeader = {
        //   headerName: 'Actions',
        //   field: '',
        //   minWidth: 150,
        //   width: 150,
        //   suppressSizeToFit: true,
        //   suppressSorting: true,
        //   suppressMenu: true,
        //   cellRenderer: function (params) {

        //       let content = '';
        //       content += '<i id="takeAssessment" class="material-icons custom-icons rotate180">keyboard_backspace</i>';
        //       //content += '<a id="takeAssessment" class="link" style="vertical-align:middle; padding-right:7px;">Begin assessment</a>'; 

        //        if(params.data.Is360){
        //            content += '<i id="assignRaters" class="material-icons custom-icons">group</i>';
        //        }
        //       return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';
        //   }
        //};
        //columnDefs.push(actionsHeader);

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 175,
            width: 200,
            suppressSizeToFit: false, 
            // headerCheckboxSelection: true,
            // headerCheckboxSelectionFilteredOnly: true,
            // checkboxSelection: true,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'NicheName',
        //    minWidth: 140,
        //    width: 150,
        //    suppressSizeToFit: true,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(nicheHeader);

        //let typeHeader = {
        //    headerName: '360',
        //    field: 'Is360',
        //    minWidth: 100,
        //    width: 150,
        //    suppressSizeToFit: true,
        //    cellRenderer: function (params) {
        //        if (params.value) {
        //            return "Yes";
        //        } else {
        //            return "No";
        //        }
        //    }
        //};
        //columnDefs.push(typeHeader);

        //let versionHeader = {
        //    headerName: 'Version',
        //    field: '',
        //    minWidth: 100,
        //    width: 130,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        let version = params.data['MajorVersion'] + "." + params.data['MinorVersion'];
        //        return version;
        //    }
        //};
        //columnDefs.push(versionHeader);

        let coachHeader = {
            headerName: 'Coach',
            field: '',
            minWidth: 175,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                let coach  = params.data['CoachFirstName'] + " " + params.data['CoachLastName'];
                return coach;
            }
        };
        columnDefs.push(coachHeader);

        let completedHeader = {
            headerName: 'Assigned on',
            field: 'AssignedOn',
            minWidth: 175,
            width: 175,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                console.log(params);
                return params.value
            },
            comparator: this.createDateComparator
        };
        columnDefs.push(completedHeader);

        return columnDefs;
    }

    createDateComparator(date1, date2) {
        date1 = new Date(date1.slice(0, -2) + ':00');
        date2 = new Date(date2.slice(0, -2) + ':00');

        console.log('comparator');
        return date2 - date1;
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            this.takeAssessment(data['AssessmentId'], data['AssignmentId'], data['Name'], data['Language']);

            //switch (e.event.target.id) {
            //    case 'takeAssessment':
            //    {
            //        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //        this.takeAssessment(data['AssessmentId'], data['AssignmentId']);
            //        break;
            //    }

            //    case 'assignRaters':
            //    {
            //        this.assignRaters(data['AssignmentId'], data['Is360']);
            //    }
            //}
        }
    }

    assignRaters(assignmentId: number, is360: boolean){
        if (is360) {
            this.ratersHeaders = this.createRatersHeaders();
            this.getRaters(assignmentId);
            this.showModal();
        }
    }

    takeAssessment(assessmentId: number, assignmentId: number, name: string, language: string) {
        console.log('takeAssessment');
        this.router.navigate(
            ['/app/assigned_assessment', 'pending', assessmentId, assignmentId, name, language],
            {state: { showBanner: false }});
    }


    /*RATERS*/

    onGridReadyModal(params) {
        this.gridApiModal = params.api;
        this.sizeToFit(this.gridApiModal);
    }

    getRaters(asignmentId: number) {
        this.asignmentId = asignmentId;

        this._ClientsService.getRaters(this.asignmentId).subscribe((data: any) => {
            console.log('response_GetRaters', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.raters = _data;
                this.loading = false;
                this.sizeToFit(this.gridApiModal);
            }
        });
    }

    createRatersHeaders() {
        let columnDefs = new Array();
        console.log('header');

        let emailHeader = {
            headerName: 'Email',
            field: 'Email',
            minWidth: 200,
            width: 255,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(emailHeader);

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        let relationshipHeader = {
            headerName: 'Relationship',
            field: 'Relationship',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(relationshipHeader);

        let addedByHeader = {
            headerName: 'AddedBy',
            field: 'AddedBy',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(addedByHeader);

        let statusHeader = {
            headerName: 'Status',
            field: 'Status',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                switch (params.value) {
                    case 1:
                        return '<div style="overflow:hidden !important;text-overflow:ellipsis;">Pending</div>';
                    case 2:
                        return '<div style="overflow:hidden !important;text-overflow:ellipsis;">In progress</div>';
                    case 3:
                        return '<div style="overflow:hidden !important;text-overflow:ellipsis;">Completed</div>';
                }
            }
        };
        columnDefs.push(statusHeader);

        return columnDefs;
    }


    showNewRaterModal() {
        this.rater.email = "";
        $('#raterTypesSelect option').eq(0).prop('selected', true);
        $('#addModal').modal('show');
    }

    closeNewRaterModal() {
        $('#addModal').modal('hide');
        console.log('hide');
    }

    getRaterTypes() {
        this._ClientsService.getRaterTypes().subscribe((data: any) => {
            console.log('response_GetRaterTypes', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.raterTypes = _data;
                this.rater.raterType = _data[0].Id;
            }
        });
    }

    saveRater() {
        let rater = new RaterDto();

        //rater.Email = this.rater.email;
        //rater.RaterType = this.rater.raterType;
        rater.AsignmentId = this.asignmentId;

        console.log("Rater", rater);

        //if (rater.Email == "") {
        //    this._toastr.warning('Empty fields', 'ELI');
        //    return;
        //}

        //if (!this.validateEmail(rater.Email)) {
        //    return;
        //}

        this._ClientsService.postSaveRaters(rater).subscribe((data: any) => {
            console.log('response_PostSaveRater', data);
            if (this._Globals.validationToken(data.result.Result)) {

                this.getRaters(this.asignmentId);
                if (data.result.Result == 1) {
                    this.closeNewRaterModal();
                    this._toastr.success('Client added successfully', 'ELI');
                } else {
                    this._toastr.error('We are sorry. An error happend while trying to save the client.', 'ELI');
                }
            }
        });
    }

    validateEmail(email: string): boolean {
        console.log("email", email);

        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let validEmail = regex.test(email);
        console.log('Valid', validEmail)
        if (validEmail) return true;
        else {
            this._toastr.warning('Please enter a valid email address', "ELI");
            return false;
        }
    }

    preventSpace(value: string, event: any, tagId: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $(`#${tagId}`).val('');
        }
    }

}
